import { Http } from './http';

class HistoricalPaymentHttp extends Http {
  prefix = 'historial-payments';

  async updateBulk(params: UpdateBulkParams): Promise<number> {
    const { data } = await this.put<number>('/update-bulk', params);

    return data;
  }
}

export const historicalPaymentHttp = new HistoricalPaymentHttp();

interface UpdateBulkParams {
  selectedIds: number[];
  prop: string;
  value: string | number | null;
}

